import { render, staticRenderFns } from "./deleteNote.vue?vue&type=template&id=f30fc0ea&"
import script from "./deleteNote.vue?vue&type=script&lang=js&"
export * from "./deleteNote.vue?vue&type=script&lang=js&"
import style0 from "./deleteNote.vue?vue&type=style&index=0&id=f30fc0ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports